import React, { useEffect, useState } from 'react';
import './preloader.scss';

const Preloader = () => {
  const [isLoaded, setIsLoaded] = useState(() => sessionStorage.getItem("portfolio-preloader-seen") === "true");

  useEffect(() => {
    if (isLoaded) return undefined;

    let timer;
    const reveal = () => {
      timer = window.setTimeout(() => {
        sessionStorage.setItem("portfolio-preloader-seen", "true");
        setIsLoaded(true);
      }, 400);
    };

    if (document.readyState !== "loading") {
      reveal();
    } else {
      document.addEventListener("DOMContentLoaded", reveal, { once: true });
    }

    return () => {
      document.removeEventListener("DOMContentLoaded", reveal);
      window.clearTimeout(timer);
    };
  }, [isLoaded]);

  // useEffect(() => {
  //   const handleWindowLoad = () => {
  //     setIsLoaded(true);
  //     document.body.classList.add("loaded");
  //   };

   
  //   if (document.readyState === 'complete') {
  //     handleWindowLoad();
  //   } else {
  //     window.addEventListener("load", handleWindowLoad);
  //   }

  //   return () => window.removeEventListener("load", handleWindowLoad);
  // }, []);

  if (isLoaded) return null;

  return (
    <div className="preload" data-preaload role="status" aria-label="Loading portfolio">
      <div className="circle"></div>
      <p className="text t-color">ABILASHA WICKRAMARATHNA</p>
    </div>
  );
}

export default Preloader;
